import Equipments from './Equipments';

export default Equipments;
